var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 670.071,
    viewBox: "0 0 800 670.071",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-646 -172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7H21.411V32.489H0Z",
    transform: "translate(1330.645 467.279)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.348,675.48h-12.5L737.9,627.268H756.35Z",
    transform: "translate(632.405 153.149)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.348,675.48h-12.5L690.9,627.268H709.35Z",
    transform: "translate(631.486 153.149)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.748,780.692V410.673a8.593,8.593,0,0,1,8.593-8.593h38.345a8.593,8.593,0,0,1,8.593,8.593h0V781.656Z",
    transform: "translate(451.961 58.271)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.748,783.888V489.673a8.593,8.593,0,0,1,8.593-8.593h38.345a8.593,8.593,0,0,1,8.593,8.593h0V783.254Z",
    transform: "translate(448.61 56.234)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.67,425.274a2.922,2.922,0,0,1-2.175-4.874L393.707,277.393l126.18,70.855,126.93-218.711L776.124,235.966a2.923,2.923,0,0,1-3.715,4.513L648.418,138.425,522.05,356.166,394.931,284.784,269.847,424.3A2.915,2.915,0,0,1,267.67,425.274Z",
    transform: "translate(454.642 65.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.278,
    cy: 27.278,
    r: 27.278,
    transform: "translate(694.547 460.37)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.278,
    cy: 27.278,
    r: 27.278,
    transform: "translate(821.196 319.108)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.278,
    cy: 27.278,
    r: 27.278,
    transform: "translate(947.845 390.226)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.278,
    cy: 27.278,
    r: 27.278,
    transform: "translate(1074.494 172)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.547,
    cy: 28.547,
    rx: 28.547,
    ry: 28.547,
    transform: "translate(1315.227 354.343)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898,560.825c10.685,1.287,38.008-8.46,39.489,6.368,14.063,41.4,13.646,200.093,13.646,200.093l-21.411,1.02s-17.109-126.092-25.2-153.068c-4.06,32.788-3.348,158.166-3.348,158.166l-19.371,1.019s-17.376-106.764-17.475-138.1c-2.112-22.954,3.068-56.968.851-79.158A84.843,84.843,0,0,0,898,560.825Z",
    transform: "translate(441.747 43.604)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.748,779.008V352.538c0-5.469,3.847-9.9,8.593-9.9h38.345c4.745,0,8.593,4.434,8.593,9.9V780.124Z",
    transform: "translate(441.908 59.803)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.574,444.408a133.211,133.211,0,0,0-15.609-24.642,39.07,39.07,0,0,1-3.466-4.731c-2.192-3.8-2.845-8.269-4.231-12.428-3.874-11.664-13.54-21.033-15.895-33.095-.857-4.384-8.091,8.358-6.189,13.794,3.4,9.839,3.833,20.258,8.156,29.761s9.4,18.617,13.132,28.333c2.121,5.516,3.813,11.215,6.923,16.313s7.963,9.37,13.825,10.134a34.1,34.1,0,0,1,1.662-10.889C862.156,452.942,864.42,448.211,862.574,444.408Z",
    transform: "translate(440.83 39.919)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.832,450.936a56.339,56.339,0,0,1,3.314-21.186c.938-2.6,2.039-5.241,1.947-8-.133-2.569-1.356-4.924-2.467-7.249-3.834-8-6.525-16.486-9.176-24.948l-5.1-15.956c-1.662-1.219,8.044-1.641,10.114,1.224,6.77,9.4,11.9,20.2,17.261,30.464a51.565,51.565,0,0,1,3.487,7.636,42,42,0,0,1,1.835,13.193c0,8.35-1.1,16.67-2.243,24.948-.724,5.19-1.672,10.838-5.6,14.274C934.13,460.112,930.031,455.014,924.832,450.936Z",
    transform: "translate(442.712 39.997)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.156,
    cy: 21.156,
    rx: 21.156,
    ry: 21.156,
    transform: "translate(1319.432 442.75)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.3,400.1a3.673,3.673,0,0,1,.774-3.8c.528-.416,1.23-.572,1.8-.969a7.751,7.751,0,0,0,1.937-2.45,10.517,10.517,0,0,1,13.161-3.341c3.5,1.83,5.607,5.494,8.716,7.961,1.579,1.278,3.409,2.227,5,3.506a20.54,20.54,0,0,1,6.479,10.479,59.459,59.459,0,0,1,1.8,12.362,11.114,11.114,0,0,1-.145,3.758,10.52,10.52,0,0,1-1.423,2.905c-3.2,4.842-7.409,9.239-12.687,11.738s-11.7,2.905-16.9.291a2.9,2.9,0,0,1-1.3-1.036,3.73,3.73,0,0,1-.2-2.237,15.313,15.313,0,0,0-1.685-8.571c-.969-1.937-2.422-3.6-3.2-5.607a19.535,19.535,0,0,1-.911-6.953C882.418,412.045,882.832,405.973,881.3,400.1Z",
    transform: "translate(442.085 42.695)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.747,785.574V579.681c0-2.64,3.847-4.781,8.593-4.781h38.345c4.745,0,8.593,2.143,8.593,4.781v206.43Z",
    transform: "translate(455.312 53.816)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.443,793.849H190.39a.974.974,0,0,1,0-1.948H988.442a.974.974,0,0,1,0,1.948Z",
    transform: "translate(456.584 48.222)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.747,777.3V293.338c0-6.207,3.847-11.239,8.593-11.239h38.345c4.745,0,8.593,5.032,8.593,11.239V778.564Z",
    transform: "translate(445.259 61.363)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.176,
    cy: 9.176,
    rx: 9.176,
    ry: 9.176,
    transform: "translate(1248.247 402.263)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.176,
    cy: 9.176,
    rx: 9.176,
    ry: 9.176,
    transform: "translate(1350.202 398.185)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.482,479.982c.9-.819,8.195-43.508,8.152-44.47-.113-5.259-16.16-11.266-19.371-9.176-3.03,1.972-8.306,24.6-11.7,28.716l-3.592-6.286H885.422l-1.73,3.213c-3.746-2.257-7.115-4.337-8.317-5.026a5.4,5.4,0,0,0-1.337-.658,20.707,20.707,0,0,1-8.156-3.834c-2.345-1.8-13.228-20.7-16.144-20.2-3.293.551-14.4,10.155-14.274,19.371,1.4-.03,19.589,36.344,19.845,37.7,1.4,5.73,6.009,89.292,7.5,93.187,6.857-.663,1.444-1.845,8.081,0,7.147,1.988,14.692-.163,22.063-.958a84.746,84.746,0,0,1,9.237-.408c11.215.051,27.222.673,38.08,3.456.061-7.116-6.189-22.512-8.5-29.23a19.623,19.623,0,0,1,.031-6.056C932.091,536.863,938.061,482.7,940.482,479.982Z",
    transform: "translate(441.194 40.966)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.486,730.628s-12.794,8.933-20.48,8.549-8.839,8.361,0,9.514,32.194,1.537,34.5,0,1.537-17.678,0-18.062S737.486,730.628,737.486,730.628Z",
    transform: "translate(589.372 91.041)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.486,730.628s-12.794,8.933-20.48,8.549-8.839,8.361,0,9.514,32.194,1.537,34.5,0,1.537-17.678,0-18.062S737.486,730.628,737.486,730.628Z",
    transform: "translate(638.426 91.041)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGraph);
export default __webpack_public_path__ + "static/media/no-graph.1fce05921208daa228de686cf83d8a28.svg";
export { ForwardRef as ReactComponent };